/**
 * BalanceDisplay 컴포넌트
 * 상단바에 간단하게 표시되는 잔액 정보
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBalance } from '../hooks/useBalance';
import styles from '../styles/BalanceDisplay.module.css';

const BalanceDisplay: React.FC = () => {
    const navigate = useNavigate();
    const { balance, isLoading, error } = useBalance();

    const handleBalanceClick = () => {
        navigate('/withdrawal');
    };

    const formatBalance = (amount: number): string => {
        // 전체 숫자를 천 단위 구분자와 함께 표시하고 '원' 붙이기 (예: 74,203원)
        return `${amount.toLocaleString('ko-KR')}원`;
    };

    if (error) {
        return (
            <div className={styles['balance-display']} onClick={handleBalanceClick}>
                <span className={styles['balance-error']}>-</span>
            </div>
        );
    }

    return (
        <div className={styles['balance-display']} onClick={handleBalanceClick}>
            {isLoading ? (
                <div className={styles['balance-loading']}>
                    <div className={styles['loading-dots']}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            ) : (
                <span className={styles['balance-amount']}>
                    {formatBalance(balance)}
                </span>
            )}
        </div>
    );
};

export default BalanceDisplay;